import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UpdatePatientComponent } from './pages/update-patient/update-patient.component';

const routes: Routes = [
  { path: 'update-patient/:guid', component: UpdatePatientComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PatientRoutingModule { }
